import React from 'react';
import PropTypes from 'prop-types';
import Configuration from '../../../common/Configuration.json';
import SubSection from '../../../components/SubSection/SubSection';
import PromoCodeContainer from '../../../redux/containers/PromoCodeContainer';
import PlanUtils from '../../../services/PlanService';
import PlanIdUtil from '../../../common/PlanIdUtil';
import './Summary.scss';
import CreditSuccess from '../../creditsuccess/CreditSuccess';
import SubscriptionDiscountService from '../../../services/SubscriptionDiscountService';
import CheckImage from '../../../components/InfoBox/Check.svg';

const Summary = (props) => {
  const { selectedPlan } = props;

  let deliveryName;
  let deliveryBuilding;
  let deliveryStreet;
  let deliverySuburb;
  let deliveryCity;
  let deliveryPostcode;

  if (props.modemDelivery === 'same') {
    deliveryName = `${props.firstName} ${props.lastName}`;
    deliveryBuilding = props.selectedAddressParts.building.toLowerCase();
    deliveryStreet = props.selectedAddressParts.street.toLowerCase();
    deliverySuburb = props.selectedAddressParts.suburb.toLowerCase();
    deliveryCity = props.selectedAddressParts.city.toLowerCase();
    deliveryPostcode = ''; // The post code is included in city for a connection address
  } else {
    deliveryName = props.modemCompany ? `${props.modemName}, ${props.modemCompany}` : props.modemName;
    deliveryBuilding = ''; // The building is only supplied if it is a connection address
    deliveryStreet = props.modemAddress;
    deliverySuburb = props.modemSuburb;
    deliveryCity = props.modemCity;
    deliveryPostcode = props.modemPostcode;
  }

  const connectionDate = props.connectionDate !== 'asap' && props.preferredDate
    ? props.preferredDate
    : props.connectionDate && props.connectionDate.toUpperCase();

  const credit = PlanUtils.getCredit(selectedPlan.isContract);
  const hasSubscriptionDiscount = SubscriptionDiscountService.hasDiscountWithSubscription(
    selectedPlan.isContract, props.discountWithSubscription
  );
  const showPromoCode = !credit && !hasSubscriptionDiscount;

  return (
    <section className="less-padding-section">
      <div className="container">
        {credit &&
        <CreditSuccess credit={credit} />
        }
        <div className="row gray-container">
          <div className="col-sm-6">
            <div>
              <div className="row">
                <div className="col-xs-12">
                  <h4 className="heading-underline">Monthly plan</h4> {/* TODO: Use h3 with h4 styling */}
                  <SubSection
                    content={[{
                      leftContent: (
                        <div>
                          <p className="payment-summary-text">
                            <strong>{selectedPlan.label}</strong>
                          </p>
                          {props.withMobileDiscount && (
                            <p className="payment-summary-text">
                              <img
                                src={CheckImage}
                                className="check check-orange"
                                height="10"
                                alt="Check"
                                role="presentation"
                              /> Skinny Mobile Plan Discount</p>
                          )}
                          <p className="payment-summary-text">
                            <img
                              src={CheckImage}
                              className="check check-orange"
                              height="10"
                              alt="Check"
                              role="presentation"
                            /> {props.contractType} contract
                            {
                              hasSubscriptionDiscount ?
                                ` - ${SubscriptionDiscountService.getDescription(
                                  selectedPlan.isContract,
                                  props.discountWithSubscription)}`
                                : ''
                            }
                          </p>
                          {props.isByoModemSelected && (
                            <p className="payment-summary-text">
                              <img
                                src={CheckImage}
                                className="check check-orange"
                                height="10"
                                alt="Check"
                                role="presentation"
                              /> BYO Modem Discount</p>
                          )}
                        </div>
                      ),
                      rightContent: ''
                    },
                      /* ...props.withMobileDiscount ? [{
                        leftContent: <span>{Configuration.skinnyMobileCustomerDiscount.name}</span>,
                        rightContent: <span>{Configuration.skinnyMobileCustomerDiscount.amountText}</span>
                      }] : [], */
                      {
                        leftContent:
                          <p className="payment-summary-text">
                            {
                              SubscriptionDiscountService.getPaymentMessage(
                                props.isContractSelected,
                                props.discountWithSubscription)
                            }
                          </p>,
                        rightContent: <p className="payment-summary-text">${PlanIdUtil.getPlanPrice((props.isByoModemSelected ? (props.selectedPlan.price - props.byoModemDiscountPrice) : props.selectedPlan.price), props.withMobileDiscount ? [Configuration.skinnyMobileCustomerDiscount.amount] : [])}</p>,
                        emphasise: true
                      },
                      props.isByoModemSelected ? {
                        leftContent: <p className="payment-summary-text">After 12 months</p>,
                        rightContent: <p className="payment-summary-text">${PlanIdUtil.getPlanPrice(props.selectedPlan.price, props.withMobileDiscount ? [Configuration.skinnyMobileCustomerDiscount.amount] : [])}</p>,
                        emphasise: true
                      } : {},
                      {
                        isSeprate: true,
                        leftContent: <span>Connection date</span>,
                        rightContent: <span>{connectionDate}</span>
                      }]}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  {showPromoCode &&
                  <PromoCodeContainer />
                  }
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-6">
            <div>
              <div className="row">
                <div className="col-xs-12">
                  <h4 className="heading-underline">About you</h4>
                  <span className="autotest-summary-name title-case">{props.firstName} {props.lastName}</span>
                  <p className="title-case autotest-summary-address">
                    {props.selectedAddressParts.building &&
                    <span>{props.selectedAddressParts.building.toLowerCase()},&nbsp;</span>}
                    {props.selectedAddressParts.street.toLowerCase()}<br />
                    {props.selectedAddressParts.suburb.toLowerCase()}, {props.selectedAddressParts.city.toLowerCase()}
                  </p>
                  <p className="autotest-summary-email">Email: {props.email}</p>
                  {
                    props.contactNumber && <p className="autotest-summary-phone">Phone: {props.contactNumber}</p>
                  }
                </div>
              </div>

              <div className="row">
                <div className="col-xs-12">
                  {!props.isByoModemSelected ? <div>
                    <h4 className="heading-underline">Modem delivery address</h4>
                    <p className="title-case gray-container-left-content">
                      {deliveryName}<br />
                      {deliveryBuilding && <span>{deliveryBuilding},&nbsp;</span>}
                      {deliveryStreet}<br />
                      {deliverySuburb}, {deliveryCity}{deliveryPostcode && <span> {deliveryPostcode}</span>}
                    </p>
                    {props.modemDeliveryInstructions &&
                    <p className="gray-container-left-content">
                      Delivery instructions: <br />
                      <span>{props.modemDeliveryInstructions}</span>
                    </p>
                    }
                  </div>
                  : <div>
                    <h4 className="heading-underline">Modem</h4>
                    <p className="gray-container-left-content">You have opted to use your existing compatible modem</p>
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

Summary.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  contactNumber: PropTypes.string,
  connectionDate: PropTypes.string,
  preferredDate: PropTypes.string,
  selectedAddressParts: PropTypes.object,
  modemDelivery: PropTypes.string,
  modemName: PropTypes.string,
  modemCompany: PropTypes.string,
  modemAddress: PropTypes.string,
  modemSuburb: PropTypes.string,
  modemCity: PropTypes.string,
  modemPostcode: PropTypes.string,
  modemDeliveryInstructions: PropTypes.string,
  selectedPlan: PropTypes.object,
  contractType: PropTypes.string,
  discountWithSubscription: PropTypes.object,
  withMobileDiscount: PropTypes.bool,
  isContractSelected: PropTypes.bool,
  isByoModemSelected: PropTypes.bool,
  byoModemDiscountPrice: PropTypes.number,
};

export default Summary;



/** WEBPACK FOOTER **
 ** ./src/components/payment/Summary/Summary.js
 **/